




import {Vue, Component} from 'vue-property-decorator'

import Login from '@/components/Login.vue'

@Component({
  components: {
      Login
  }
})
export default class LoginView extends Vue {

}
